import type {
    AuthorizedMedicationInfoFragment,
    MedicationInfoFragment,
    UnknownMedicationInfoFragment,
} from '../../graphql/generated/graphql';
import type { MedicationConfigOverride } from '../../hooks/use-config-api';

export const getSavingsAmount = (
    medication:
        | AuthorizedMedicationInfoFragment
        | MedicationInfoFragment
        | UnknownMedicationInfoFragment,
    discountedPrice: number,
    configOverride: MedicationConfigOverride
): number | undefined => {
    const ndc =
        medication.__typename === 'UnknownMedication'
            ? medication.originalNdc || medication.id
            : medication.id;

    const regularPrice = configOverride.staticPricing.regularPrices?.[ndc];
    if (!regularPrice) {
        return undefined;
    }

    return regularPrice - discountedPrice;
};

export const getSavingsAmountByNdc = (
    ndc: string,
    discountedPrice: number,
    configOverride: MedicationConfigOverride
): number => {
    const regularPrice = configOverride.staticPricing.regularPrices?.[ndc];
    if (!regularPrice) {
        return 0;
    }

    return regularPrice - discountedPrice;
};
